var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00012207 0H28.9999V29.5927H0.00012207V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95949 0.811022C6.35249 2.04602 3.28049 4.74402 1.57749 8.15402C0.984491 9.32902 0.551491 10.583 0.291491 11.873C-0.362509 15.087 0.0924907 18.513 1.57549 21.44C2.53849 23.351 3.92049 25.05 5.59549 26.381C7.17649 27.642 9.01849 28.573 10.9725 29.092C13.4365 29.753 16.0605 29.738 18.5415 29.174C20.7845 28.658 22.9055 27.586 24.5995 26.022C26.3905 24.377 27.6675 22.209 28.3435 19.879C29.0815 17.338 29.1825 14.625 28.7205 12.024C24.0795 12.022 19.4375 12.023 14.7965 12.024C14.7965 13.949 14.7935 15.874 14.7975 17.798C17.4855 17.798 20.1735 17.797 22.8605 17.798C22.5495 19.643 21.4525 21.33 19.8985 22.369C18.9205 23.026 17.7985 23.452 16.6405 23.655C15.4755 23.854 14.2715 23.879 13.1095 23.644C11.9275 23.408 10.7995 22.916 9.81549 22.222C8.24149 21.116 7.04049 19.499 6.42349 17.678C5.79349 15.826 5.78849 13.766 6.42649 11.916C6.86949 10.612 7.60649 9.40802 8.57449 8.42802C9.76849 7.20502 11.3205 6.33102 12.9935 5.97302C14.4255 5.66702 15.9355 5.72602 17.3375 6.15002C18.5295 6.51202 19.6275 7.16502 20.5275 8.02402C21.4375 7.12002 22.3425 6.21002 23.2505 5.30402C23.7265 4.81602 24.2265 4.35002 24.6885 3.84902C23.3095 2.57302 21.6925 1.54702 19.9265 0.898022C16.7465 -0.271978 13.1605 -0.296978 9.95949 0.811022Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 24,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57751 0H24.6885V11.916H1.57751V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95951 0.811022C13.1605 -0.296978 16.7465 -0.271978 19.9265 0.898022C21.6925 1.54702 23.3095 2.57302 24.6885 3.84902C24.2265 4.35002 23.7265 4.81602 23.2505 5.30402C22.3425 6.21002 21.4375 7.12002 20.5275 8.02402C19.6275 7.16502 18.5295 6.51202 17.3375 6.15002C15.9355 5.72602 14.4255 5.66702 12.9935 5.97302C11.3205 6.33102 9.76851 7.20502 8.57451 8.42802C7.60651 9.40802 6.86951 10.612 6.42651 11.916C4.81051 10.662 3.19451 9.40702 1.57751 8.15402C3.28051 4.74402 6.35251 2.04602 9.95951 0.811022Z",
    fill: "#E94435"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.291182 11.8727C0.551182 10.5827 0.984182 9.32869 1.57718 8.15369C3.19418 9.40769 4.81018 10.6617 6.42618 11.9157C5.78818 13.7657 5.79318 15.8267 6.42318 17.6777C4.80818 18.9317 3.19318 20.1877 1.57518 21.4407C0.0931816 18.5127 -0.362818 15.0867 0.291182 11.8727Z",
    fill: "#F8BB15"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 12,
    width: 15,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7958 12.0225H28.9999V26.0225H14.7958V12.0225Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_35)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7962 12.0235C19.4372 12.0225 24.0792 12.0215 28.7201 12.0245C29.1832 14.6255 29.0812 17.3385 28.3432 19.8795C27.6672 22.2095 26.3902 24.3765 24.6002 26.0225C23.0342 24.8025 21.4632 23.5895 19.8982 22.3685C21.4532 21.3295 22.5492 19.6425 22.8612 17.7985C20.1732 17.7975 17.4852 17.7975 14.7972 17.7985C14.7942 15.8735 14.7972 13.9485 14.7962 12.0235Z",
    fill: "#547DBE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57544 21.4403C3.19344 20.1883 4.80744 18.9323 6.42344 17.6783C7.04044 19.4983 8.24144 21.1163 9.81544 22.2213C10.7994 22.9153 11.9274 23.4083 13.1094 23.6443C14.2714 23.8793 15.4754 23.8533 16.6404 23.6553C17.7984 23.4523 18.9214 23.0253 19.8984 22.3683C21.4634 23.5893 23.0344 24.8023 24.5994 26.0223C22.9054 27.5863 20.7844 28.6573 18.5414 29.1733C16.0604 29.7383 13.4374 29.7533 10.9724 29.0923C9.01844 28.5723 7.17644 27.6413 5.59544 26.3813C3.92044 25.0493 2.53844 23.3513 1.57544 21.4403Z",
    fill: "#34A751"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e1d540d155775db2197907e0abcf82c9.svg";
export { ForwardRef as ReactComponent };